import { TextFieldWidget } from '@tableau/widgets';
import React = require('react');
import { Formatters, Messages } from '~src/codegen/Localize';

import { editGroupDialogFieldStyles, editGroupDialogLabelStyles, editGroupNameFieldStyles } from '../styles/EditGroupDialogStyles';
import { EditGroupDialogLabel } from './EditGroupDialogLabel';

export interface EditGroupNameFieldProps {
  readonly name: string;
  readonly groupNameError: string;
  readonly setName: (name: string) => void;
  readonly setGroupNameError: (errorMsg: string) => void;
}

export const CHARACTER_LIMIT = 255;

export function EditGroupNameField(props: EditGroupNameFieldProps): JSX.Element  {
    const setName = (name: string) => {
      const isValid = name.length <= CHARACTER_LIMIT ? true : false;
      const groupNameErrorMsg = isValid ? undefined : Messages.characterLimitExceeded({
        COUNT_LOC: Formatters.formatCount(name.length),
        LIMIT_LOC: Formatters.formatCount(CHARACTER_LIMIT)
      });
      props.setName(name);
      props.setGroupNameError(groupNameErrorMsg);
    };

    return (
      <div style={editGroupDialogFieldStyles}>
        <EditGroupDialogLabel message={Messages.groupName()} style={editGroupDialogLabelStyles} />
        <TextFieldWidget
          label={''}
          testId='edit-group-name-field'
          onChange={e => setName(e.target.value)}
          onClear={() => setName('')}
          value={props.name}
          message={props.groupNameError ? props.groupNameError : undefined}
          valid={!props.groupNameError ? undefined : false }
          style={editGroupNameFieldStyles}
        />
      </div>
    );
}